export const UI = {
  en: {
    home: 'Home',
    services: 'Services',
    ourServices: (c) => `Our Services for Businesses in ${c}`,
    learnMore: 'Learn more',
    included: "What's Included",
    how: 'How We Work',
    compliance: (c) => `Compliance & Data Protection in ${c}`,
    projects: (c) => `Typical Projects in ${c}`,
    faq: 'Frequently Asked Questions',
    why: 'Why Jotunheims',
    proof: 'In-House Products as Proof',
    resources: 'Resources',
    resourceNote: '',
    serving: 'Serving businesses in',
    remote: 'We serve clients remotely from our headquarters in Dubai Silicon Oasis, UAE.',
    globalLink: 'See the global / Dubai version of this service',
    otherServices: 'Other services',
    contactTitle: 'Tell Us About Your Project',
    contactText: 'Share a few details and our team will reply with next steps.',
    name: 'Full Name', email: 'Email', company: 'Company', message: 'Message',
    namePh: 'Enter your name', companyPh: 'Your organization', messagePh: 'Describe your project...',
    send: 'Send Message', sending: 'Sending...', sent: 'Message Sent', sentText: "We'll be in touch shortly.",
    error: 'Failed to send message. Please try again or contact us on WhatsApp.',
    whatsapp: 'Chat on WhatsApp',
    effective: 'Effective date',
    officeTitle: (city) => `Our Office in ${city}`
  },
  es: {
    home: 'Inicio',
    services: 'Servicios',
    ourServices: (c) => `Nuestros servicios para empresas en ${c}`,
    learnMore: 'Saber más',
    included: 'Qué incluye',
    how: 'Cómo trabajamos',
    compliance: (c) => `Protección de datos en ${c}`,
    projects: (c) => `Proyectos típicos en ${c}`,
    faq: 'Preguntas frecuentes',
    why: 'Por qué Jotunheims',
    proof: 'Productos propios como prueba',
    resources: 'Recursos',
    resourceNote: '(en inglés)',
    serving: 'Damos servicio a empresas en',
    remote: 'Atendemos a nuestros clientes en remoto desde nuestra sede en Dubai Silicon Oasis (EAU).',
    globalLink: 'Ver la versión global / Dubái de este servicio (en inglés)',
    otherServices: 'Otros servicios',
    contactTitle: 'Cuéntanos tu proyecto',
    contactText: 'Déjanos algunos datos y nuestro equipo te responderá con los siguientes pasos.',
    name: 'Nombre completo', email: 'Correo electrónico', company: 'Empresa', message: 'Mensaje',
    namePh: 'Escribe tu nombre', companyPh: 'Tu empresa', messagePh: 'Describe tu proyecto...',
    send: 'Enviar mensaje', sending: 'Enviando...', sent: 'Mensaje enviado', sentText: 'Te responderemos muy pronto.',
    error: 'No se pudo enviar el mensaje. Inténtalo de nuevo o escríbenos por WhatsApp.',
    whatsapp: 'Escríbenos por WhatsApp',
    effective: 'Fecha de entrada en vigor',
    officeTitle: (city) => `Nuestra oficina en ${city}`
  }
};